import LinkOffIcon from '@mui/icons-material/LinkOff';
import { Button, IconButton, Stack } from '@mui/material';
import { EnhancedDialog } from 'components/enhanced';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextCancelButton } from '../buttons/CancelButton';
import { TextConfirmButton } from '../buttons/ConfirmButton';

interface ConfirmationButtonDialogProps {
  id?: number;
  message?: string;
  iconButton?: boolean;
  handleUnlink?: (id?: number, pars?: string) => void;
  pars?: string; // unlink "fonti di costi"
}

export default function ConfirmationUnlinkButtonDialog(params: ConfirmationButtonDialogProps) {
  const { id, iconButton, message, handleUnlink, pars } = params;
  const { t } = useTranslation();

  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const handleConfirmUnlink = () => {
    handleUnlink(id ? id : null, pars ? pars : null);
    // Close the dialog and reset the selected row ID.
    setOpenDialog(false);
  };

  return (
    <>
      {iconButton ? (
        <IconButton
          onClick={handleOpenDialog}
          color="error"
          size="small"
          sx={{
            '&:hover': {
              backgroundColor: 'error.lighter'
            }
          }}>
          <LinkOffIcon />
        </IconButton>
      ) : (
        <Button onClick={handleOpenDialog} color="error">
          <LinkOffIcon /> {t('actions.unlink')}
        </Button>
      )}
      <EnhancedDialog
        open={openDialog}
        onClose={handleCloseDialog}
        title={t('actions.confirmation.unlink')}
        maxWidth="sm"
        costumFooter={
          <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ width: '100%' }}>
            <TextCancelButton handleCloseDialog={handleCloseDialog} />
            <TextConfirmButton handleConfirm={handleConfirmUnlink} label={t('actions.confirm')} />
          </Stack>
        }>
        {message ? message : 'Sei sicuro di voler scollegare questo elemento?'}
      </EnhancedDialog>
    </>
  );
}
